import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./../Styles/about.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";

import Profile from "./Profie";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
function DynamicImage({ name, defaultImage, alt, className, ...props }) {
  const extensions = ["jpg", "jpeg", "png", "webp", "gif", "svg", "avif"];
  const [index, setIndex] = useState(0);

  const src =
    index < extensions.length
      ? `/images/about/${name}.${extensions[index]}`
      : defaultImage;

  const handleError = () => {
    if (index < extensions.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  return (
    <img
      {...props}
      src={src}
      alt={alt || name}
      className={className}
      onError={handleError}
    />
  );
}
export default function About() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-in-out",
    });
  }, []);
  const [showLogin, setShowLogin] = useState(false);

  const [showProfile, setShowProfile] = useState(false);

  const navigate = useNavigate();

  const handleListing = (path, serviceName) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    // Not logged in
    if (!loginUser) {
      navigate("/register", {
        state: {
          redirectTo: path,
          service: serviceName,
        },
      });
      return;
    }

    // Admin can access everything
    if (loginUser.role === "admin") {
      navigate(path);
      return;
    }

    // Get provider options
    let providerOptions = loginUser.provider_options || [];

    // Handle if backend sends string instead of array
    if (typeof providerOptions === "string") {
      try {
        providerOptions = JSON.parse(providerOptions);
      } catch {
        providerOptions = providerOptions
          .split(",")
          .map((item) => item.trim().toLowerCase());
      }
    }

    // Make sure it is an array
    if (!Array.isArray(providerOptions)) {
      providerOptions = [];
    }

    providerOptions = providerOptions.map((item) => String(item).toLowerCase());

    // User has the required provider option
    if (providerOptions.includes(serviceName.toLowerCase())) {
      navigate(path);
      return;
    }

    // User is logged in but does not have this provider option
    setShowProfile(true);
  };
  return (
    <div className="eb-about-page">
      {/* Hero Section */}
      <section className="eb-about-hero">
        <div className="container text-center">
          <h1 className="eb-hero-title" data-aos="fade-down">
            About Embroidery Bazar
          </h1>
          <p
            className="eb-hero-subtitle"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            India's trusted marketplace for embroidery machines, workspace,
            designers, and embroidery services.
          </p>
        </div>
      </section>

      <div className="container">
        {/* buy design */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="1_buy_design"
                  alt="Buy Embroidery Designs"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <span className="eb-about-tag">Design Marketplace</span>

              <h2 className="eb-zigzag-heading">Buy Embroidery Designs</h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Browse premium machine embroidery designs
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Find designs suitable for Kurti, Saree, Blouse, Dupatta,
                  Lehenga and other products
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Easily search and filter designs according to your needs
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Purchase and download embroidery designs
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/designs")}
                >
                  <i className="bi bi-search me-2"></i>
                  Buy Design
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Sell design */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-2 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="2_sell_design"
                  alt="Sell Embroidery Designs"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              <span className="eb-about-tag">For Designers</span>

              <h2 className="eb-zigzag-heading">Sell Embroidery Designs</h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Upload and sell your own embroidery designs
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Showcase your designs with images and detailed information
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Add categories, pricing and other design details
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Manage your uploaded designs from your seller dashboard
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  onClick={() => handleListing("/user/designs", "designs")}
                >
                  <i className="bi bi-palette-fill me-2"></i>
                  Sell Design
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* upload Work */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* IMAGE */}
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="3_upload_work"
                  alt="Post Embroidery Work"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-6 order-lg-2" data-aos="fade-right">
              <span className="eb-about-tag">Work Marketplace</span>

              <h2 className="eb-zigzag-heading">
                Post Your Embroidery Design Work Requirements
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Add complete Embroidery design work details and instructions
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Upload reference images or required files
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Receive bids from experienced embroidery designers
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Compare different designers and their bid prices
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Select a designer according to your requirements
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Track work progress and delivery status
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  onClick={() => handleListing("/user/add-work", "job_worker")}
                >
                  <i className="bi bi-plus-circle-fill me-2"></i>
                  Post Work Requirements
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* work from home */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* IMAGE */}
            <div className="col-lg-6 order-lg-2 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="4_work_fromhome"
                  alt="Find Embroidery Work and Place Bid"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-6 order-lg-1" data-aos="fade-left">
              <span className="eb-about-tag">For Embroidery Designers</span>

              <h2 className="eb-zigzag-heading">
                Find Embroidery Design Work From Home
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  View complete Embroidery Design work requirements and details
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Check reference images and project information
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Enter your own bid price for the project
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Submit your bid directly to the work owner
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Manage your submitted bids easily
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Complete assigned work and deliver your embroidery files
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/work-list")}
                >
                  <i className="bi bi-briefcase-fill me-2"></i>
                  Find Work & Place Bid
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Create Profile */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="5_create_profile"
                  alt="Designer"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
            <div className="col-lg-6 order-lg-2" data-aos="fade-right">
              <span className="eb-about-tag">Designers and Sketchers</span>
              <h2 className="eb-zigzag-heading">Create Your Profile</h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Create your Designer
                  and Sketchers Profile
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Showcase your skills and experience
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Add your details and expertise
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Build your
                  professional network
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-designer")}
                  onClick={() =>
                    handleListing("/user/add-designer", "designers")
                  }
                >
                  <i className="bi bi-person-badge-fill me-2"></i>
                  Create Profile
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Explore designer */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* Image */}
            <div className="col-lg-6 p-4 order-lg-2" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="6_explore_designer"
                  alt="Hire Designers and Sketchers"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            {/* Content */}
            <div className="col-lg-6 order-lg-1" data-aos="fade-left">
              <span className="eb-about-tag">Hire Designers and Sketchers</span>

              <h2 className="eb-zigzag-heading">
                Find Experienced Designers and Sketchers
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Find experienced embroidery designers and sketchers
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Explore professional profiles and expertise
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Choose professionals according to your requirements
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect directly with designers and sketchers
                </li>
              </ul>

              <div className="eb-action-btns ">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/designer")}
                >
                  <i className="bi bi-person-check-fill me-2"></i>
                  Explore & Hire Designer
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* sell machine */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-2" data-aos="fade-left">
              <span className="eb-about-tag">Machine Marketplace</span>

              <h2 className="eb-zigzag-heading">
                Sell Old Embroidery Machines
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Sell your old embroidery machine easily
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Add machine photos and complete details
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Set your expected selling price
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect directly with interested buyers
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  onClick={() => handleListing("/user/add-machine", "machines")}
                >
                  <i className="bi bi-gear-fill me-2"></i>
                  Sell Machine
                </button>
              </div>
            </div>

            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="7_sell_machine"
                  alt="Sell Embroidery Machine"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        {/* buy machine */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1" data-aos="fade-left">
              <span className="eb-about-tag">Machine Marketplace</span>

              <h2 className="eb-zigzag-heading">Buy Old Embroidery Machines</h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Browse used embroidery machines
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Find machines according to your requirements
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Compare available machine listings
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Direct contact with sellers
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/machine")}
                >
                  <i className="bi bi-cart-check-fill me-2"></i>
                  Buy Machine
                </button>
              </div>
            </div>

            <div className="col-lg-6 order-lg-2 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="8_buy_machine"
                  alt="Buy Embroidery Machine"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        {/* find workspace */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="9_find_workspace"
                  defaultImage="/images/suppliers.jpg"
                  alt="Find Workspace"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            <div className="col-lg-6 order-lg-2" data-aos="fade-right">
              <span className="eb-about-tag">Find Workspace</span>

              <h2 className="eb-zigzag-heading">
                Find Machine Workspace On Rent
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Find ready-to-use embroidery workspaces
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Search workspace by city and location
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Check available workspace details
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Contact workspace owners directly
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/house")}
                >
                  <i className="bi bi-search me-2"></i>
                  Find Workspace On Rent
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* give workspace */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-2 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="10_give_workspace"
                  defaultImage="/images/suppliers.jpg"
                  alt="Provide Workspace"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              <span className="eb-about-tag">Provide Workspace</span>

              <h2 className="eb-zigzag-heading">
                Rent Out Your Machine Workspace
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  List your available workspace
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Add workspace photos and facilities
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Set your rental price and availability
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect directly with interested users
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  onClick={() =>
                    handleListing("/user/add-workspace", "workspaces")
                  }
                >
                  <i className="bi bi-building-add me-2"></i>
                  Give Workspace On Rent
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* find supplier */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-2" data-aos="fade-right">
              <span className="eb-about-tag">Suppliers</span>
              <h2 className="eb-zigzag-heading">
                Find Embroidery Material Suppliers
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Find thread suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Find beads suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Find spareparts
                  suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Find sequin suppliers
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/supplier")}
                >
                  <i className="bi bi-truck me-2"></i>
                  Find Suppliers
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-4 order-lg-1" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="11_find_suppliers"
                  defaultImage="/images/suppliers.jpg"
                  alt="Suppliers"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        {/* become supplier */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              <span className="eb-about-tag">Suppliers</span>
              <h2 className="eb-zigzag-heading">
                Promote your supplier business
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Promote your supplier
                  business
                </li>
                <li>
                  <span className="eb-check-icon">✔</span>
                  Showcase your products and services
                </li>
                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect with potential customers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Increase business
                  visibility
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-supplier")}
                  onClick={() =>
                    handleListing("/user/add-supplier", "supplier")
                  }
                >
                  <i className="bi bi-boxes me-2"></i>
                  Promote your supplier business
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-4 order-lg-2" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="12_become_supplier"
                  defaultImage="/images/Promote_supplier_business.jpg"
                  alt="Suppliers"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        {/* hire designer */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* CONTENT */}
            <div className="col-lg-6 order-lg-2" data-aos="fade-left">
              <span className="eb-about-tag">Designer Requirements</span>

              <h2 className="eb-zigzag-heading">
                Find the Right Embroidery Designer for Your Requirement
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Post your designer requirement
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Mention required skills and experience
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Specify your work type and requirements
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Receive responses from interested designers
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Compare designer profiles and experience
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect with the right designer
                </li>
              </ul>

              <div className="eb-action-btns">
                {/* OWNER POSTS REQUIREMENT */}
                <button
                  className="eb-light-btn primary"
                  onClick={() =>
                    handleListing("/user/add-hiring", "job_worker")
                  }
                >
                  <i className="bi bi-person-plus-fill me-2"></i>
                  Post Designer Requirement
                </button>

                {/* DESIGNER FINDS REQUIREMENTS */}
                {/* <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/hiring")}
                >
                  <i className="bi bi-search me-2"></i>
                  Find Requirements
                </button> */}
              </div>
            </div>

            {/* IMAGE */}
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="13_hire_designer"
                  alt="Designer Requirement"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        <HorizontalAds />
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
          }}
        />
        {showProfile && (
          <Profile isOpen={showProfile} onClose={() => setShowProfile(false)} />
        )}
      </div>
    </div>
  );
}
